import {LogicalOperator, Property} from '../enums/expression-enums';
import type {ExpressionNode} from './expression-node';
import {OperandNode} from './operand-node';
import {OperatorNode} from './operator-node';

export function conditionalNegateExpression(node: ExpressionNode, shouldNegate: boolean): ExpressionNode {
  return shouldNegate ? new OperatorNode(LogicalOperator.Not, node, null) : node;
}

export function expressionToClauseRoot(node: ExpressionNode): OperatorNode {
  return new OperatorNode(LogicalOperator.Or, node, new OperandNode({property: Property.Literal, value: false}));
}

export function expressionToLiteralRoot(node: ExpressionNode): OperatorNode {
  return new OperatorNode(LogicalOperator.And, node, new OperandNode({property: Property.Literal, value: true}));
}
